import React from 'react';

const DynamicButton = ({name, onClick, icon, type = "submit", id = "", color=""}) => {
    return (
        <>
        <button type={type} title={name} onClick={onClick} id={id}
            style={{background: color }}
            className={`dynamic-btn px-3 mx-1 py-2 text-xs font-medium text-center opacity-[0.7] text-white rounded-lg hover:bg-${color}-800 focus:ring-4 focus:outline-none focus:ring-${color}-300 dark:bg-${color}-600 dark:hover:bg-${color}-700 dark:focus:ring-${color}-800 hover:opacity-100`}>
                {icon}
        </button>
        <style>{`
            .dynamic-btn:hover {
                opacity: 1 !important;
            }   
        `}</style>
        </>
    )
};

export default DynamicButton;